import 'react-loading-skeleton/dist/skeleton.css';

import Skeleton from 'react-loading-skeleton';

import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

function SkeletonLoading({ length }: { length: number }) {
  return (
    <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-4">
      {Array.from({ length: length }).map((_, idx) => (
        <div key={idx} className="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-bg-white tw-rounded-xl tw-shadow-sm">
          <Skeleton circle={true} height={40} width={40} />
          <div className="tw-flex-1 tw-space-y-1">
            <Skeleton height={14} width={`60%`} />
            <Skeleton height={12} width={`40%`} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default WrappedErrorBoundary(SkeletonLoading);
